import { default as MuiBaseInputAdornment, InputAdornmentProps } from '@mui/material/InputAdornment'

import { createComponentWrapperWithRef } from '../../theme'

export const InputAdornment = createComponentWrapperWithRef<InputAdornmentProps>(
  {
    mui: MuiBaseInputAdornment,
    nova: MuiBaseInputAdornment,
  },
  'InputAdornment',
)
